import React from "react";
import { List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { FiberManualRecord, InfoOutlined } from "@material-ui/icons";
import { Text } from "react-native-web";
import { enUS } from "./en-US";
import { zhHK } from "./zh-HK";
import { languageStorage } from "../../lib/LanguageStorage";
import CommonTooltip from "./CommonTooltip";

export default class PasswordPolicyTooltip extends React.Component {
  componentDidMount() {
    const getText = (language) => {
      let text = enUS;
      if (language == "zhHK") {
        text = zhHK;
      }
      return text;
    };
    languageStorage.getLanguage((language) =>
      this.setState({
        language: language,
        text: getText(language),
      })
    );
  }

  render() {
    const passwordRules = this.state?.text
      ? [
          this.state.text.minLength,
          //   this.state.text.asciiOnly,
          this.state.text.uppercaseRequired,
          this.state.text.lowercaseRequired,
          this.state.text.numberOrSpecialRequired,
        ]
      : [];

    const tooltipContent = (
      <List style={{ color: "#000" }}>
        {passwordRules.map((rule, index) => (
          <ListItem key={rule} style={{ padding: 2 }}>
            <ListItemIcon
              style={{
                alignSelf: "flex-start",
                paddingTop: "3px",
                paddingRight: "0",
                color: "black",
              }}
            >
              <FiberManualRecord style={{ fontSize: 8 }} />
            </ListItemIcon>
            <Text style={{ fontSize: 12 }}>{rule}</Text>
          </ListItem>
        ))}
      </List>
    );

    return <CommonTooltip title={tooltipContent} icon={InfoOutlined} />;
  }
}
